// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__oeYA3","menu":"navbar_menu__4RRb-","link":"navbar_link__KAMEZ"};